/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleLetterV = createReactComponent("circle-letter-v", "IconCircleLetterV", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 8l2 8l2 -8", key: "svg-1" }]
]);

export { IconCircleLetterV as default };
//# sourceMappingURL=IconCircleLetterV.js.map
